import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {notifyError} from './notifySnack';
import {ROLES} from "./constants";
import {downloadDocById, getDocument} from "../redux/actions/documents/documentsActions";
import {closeModal, setModal} from "../redux/actions/app/appActions";
import {POPUPS} from "../redux/actions/app/appActionTypes";

export function ScrollToTop() {
    const {pathname} = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

export const convertSizeUi = (size) => {
    if (size < 1000000) {
        return Math.floor(size / 1000) + ' KB';
    } else {
        return Math.floor(size / 1000000) + ' MB';
    }
};

export const concatFileExtension = (fileName) => {
    const dotIndex = fileName.lastIndexOf('.');
    if (dotIndex === -1) {
        return fileName;
    }
    return fileName.substring(0, dotIndex);
};

export const convertSizeToMB = (size) => {
    return Math.floor(size / 1000000);
};

export const clearLocalStorage = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
};

export const getIconForFormat = (format) => {
    const formatSlice = format.includes('.') ? format.replace('.', '') : format;

    try {
        const icons = require.context('../assets/icons/format/', false, /\.svg$/);
        return icons(`./${formatSlice}.svg`).default;
    } catch (e) {
        const icons = require.context('../assets/icons/format/', false, /\.svg$/);
        return icons(`./default.svg`).default;
    }
};

export const acceptGeneralFormats = {
    'video/x-msvideo': ['.avi'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'message/rfc822': ['.eml'],
    'application/x-msdownload': ['.exe'],
    'text/html': ['.html'],
    'image/jpeg': ['.jpg'],
    'video/quicktime': ['.mov'],
    'video/mp4': ['.mp4'],
    'application/pdf': ['.pdf'],
    'image/png': ['.png'],
    'application/vnd.ms-powerpoint': ['.ppt'],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
    'application/vnd.rar': ['.rar'],
    'text/plain': ['.txt'],
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    'application/zip': ['.zip']
};

export const urlToFile = async (url, filename) => {
    const response = await fetch(url, {
        headers: {
            'Cache-Control': 'no-cache'
        }
    });
    const blob = await response.blob();
    return new File([blob], filename, {type: blob.type});
};

export const base64ToFileImg = (base64String, filename) => {
    return fetch(base64String, {
        headers: {
            'Cache-Control': 'no-cache'
        }
    })
        .then((res) => res.arrayBuffer())
        .then((buffer) => new File([buffer], filename, {type: 'image/jpeg'}));
};

export const formatError = (res) => {
    const errors = res?.data?.errors;
    if (errors) {
        notifyError(
            Object.values(errors)
                .map((item) => item)
                .join(';\n') ?? 'Помилка'
        );
    } else {
        const message = res.data?.message;
        notifyError(message ?? 'Помилка');
    }
};

export const hasPermission = (permission, userPermissions) => {
    return userPermissions.includes(permission);
};

export const formatRolesByIerarchion = (currentRole, rolesList) => {
    if (!currentRole || !Array.isArray(rolesList)) {
        return [];
    }

    switch (currentRole) {
        case ROLES.HEAD_OF_BRANCH:
            return rolesList.filter((role) => role.role !== ROLES.SUPER_ADMIN);

        case ROLES.TECHNICAL_DIRECTOR:
            return rolesList.filter(
                (role) => role.role !== ROLES.SUPER_ADMIN && role.role !== ROLES.HEAD_OF_BRANCH
            );

        case ROLES.HEAD_OF_THE_SALES_DEPARTMENT: {
            return rolesList.filter((role) => role.role !== ROLES.SUPER_ADMIN && role.role !== ROLES.HEAD_OF_BRANCH && role.role !== ROLES.TECHNICAL_DIRECTOR);
        }

        default:
            return rolesList
    }
};